export const AutoAbo = {
  label: 'Auto verkaufen',
  itemId: 'carsale',
  url: '/verkaufen?customData=main_nav',
  useRouter: true,
};
